document.addEventListener("DOMContentLoaded", function() {
    // Do things on window resize
    if (window.attachEvent) {
        window.attachEvent('onresize', windowresize);
    } else {
        window.addEventListener('resize', windowresize);
    }

    /**
     * Video playlist
     */


    var vimeoIframes = document.querySelectorAll('.vimeo-player');

    // Tried adding support for multiple video players but not current working
    for (i = 0; i < vimeoIframes.length; i++) {

        var currentVideo = 1;
        var videoIds = JSON.parse(vimeoIframes[i].dataset.playlist);
        var player = new Vimeo.Player(vimeoIframes[i]);
        var vimeoThumbnails = document.querySelectorAll('.paragraph--type--video-playlist .player-thumbnails a');
        var videoCount = vimeoThumbnails.length - 1;

        player.on('ended', function() {
            if (currentVideo <= videoCount) {
                // Next video
                player.loadVideo(videoIds[currentVideo]).then(function(id) {
                    player.play();
                });
                // Update global var
                currentVideo++;
                // Handle active class
                vimeoPlayerActiveClassHandler(currentVideo);
            }
        });


        for (j = 0; j < vimeoThumbnails.length; j++) {
            vimeoThumbnails[j].addEventListener('click', function(e) {
                e.preventDefault();
                // Next video
                player.loadVideo(videoIds[this.dataset.video]).then(function(id) {
                    player.play();
                });
                // Update global var
                currentVideo = parseInt(this.dataset.video) + 1;
                // Handle active class
                vimeoPlayerActiveClassHandler(currentVideo);
            });
        }
    }

    function vimeoPlayerActiveClassHandler(eq) {
        var elems = document.querySelectorAll(".paragraph--type--video-playlist .player-thumbnails a");
        [].forEach.call(elems, function(el) {
            el.classList.remove("active");
        });
        document.querySelector(".paragraph--type--video-playlist .player-thumbnails a:nth-child(" + eq + ")").classList.add('active');

        // this.classList.add('active');
    }



    /**
     * Vue Component : Carousel
     */

    var paragraphSlideshow = document.getElementsByClassName('paragraph--type--image-slideshow');

    if (paragraphSlideshow.length) {
        for (var i = paragraphSlideshow.length - 1; i >= 0; i--) {
            var app = new Vue({
                el: paragraphSlideshow[i],
                delimiters: ['${', '}'],
                comments: true,
                components: {
                    'carousel': VueCarousel.Carousel,
                    'slide': VueCarousel.Slide
                }
            })
        }
    }

    /**
     *
     */

    //add simple support for background images:
    document.addEventListener('lazybeforeunveil', function(e) {
        var bg = e.target.getAttribute('data-bg');
        if (bg) {
            e.target.style.backgroundImage = 'url(' + bg + ')';
        }
    });

    /**
     * Do random homepage background images - added via JS to avoid cache problemo's
     */

    var yttBackgrounds = [
        '/themes/custom/tt/images/homepage-ytt-bg1.jpg',
        '/themes/custom/tt/images/homepage-ytt-bg2.jpg',
    ];

    var heritageBackgrounds = [
        '/themes/custom/tt/images/homepage-heritage-bg1.jpg',
        '/themes/custom/tt/images/homepage-heritage-bg2.jpg',
    ];

    if (document.body.className.match('page-node-type-homepage') && !document.body.className.match('page-node-type-homepage_ytt')) {

        // changeBackgroungImageOfElem('homepage-ytt-bg', yttBackgrounds[Math.floor(Math.random() * yttBackgrounds.length)]);
        changeBackgroungImageOfElem('homepage-heritage-bg', heritageBackgrounds[Math.floor(Math.random() * heritageBackgrounds.length)]);

    }

    function changeBackgroungImageOfElem(elem, image) {
        var urlString = 'url(' + image + ')';
        document.getElementById(elem).style.backgroundImage = urlString;
    }

    /**
     * Do mobile filter trigger
     */

    var filterHandle = document.getElementsByClassName('mobile-filter-handle');
    var filterBlocks = document.getElementsByClassName('filters-conditional');
    for (var z = 0; z < filterHandle.length; z++) {
        var elem = filterHandle[z];
        elem.onclick = function() {
            for (var z = 0; z < filterBlocks.length; z++) {
                var elem = filterBlocks[z];
                elem.classList.toggle('open');
            }
        };
    }

    /**
     * Do mobile menu triggers
     */

    var hamburger = document.getElementsByClassName('hamburger');
    var region_main = document.getElementsByClassName('Region--header');
    var region_ytt = document.getElementsByClassName('Region--header_bottom');

    for (var z = 0; z < hamburger.length; z++) {
        var elem = hamburger[z];
        elem.onclick = function() {
            this.classList.toggle('is-active');
            if (region_main.length) {
                region_main[0].classList.toggle('nav-active');
            }
            if (region_ytt.length) {
                region_ytt[0].classList.toggle('nav-active');
            }
        };
    }

    /**
     * Add nice horizontal scrolling to the team block
     */

    var teamScroll;
    var teamElem = document.getElementsByClassName('view-display-id-team_list_block');
    if (teamElem.length) {
        teamScrollInit();
    }

    function teamScrollInit() {
        teamScroll = new IScroll('.view-display-id-team_list_block .view-content', {
            eventPassThrough: true,
            scrollX: true,
            scrollY: false,
            mouseWheel: true,
            click: true,
            scrollbars: true
        });
    }


    /**
     * Replace the yuk status messages
     */

    var messages = [];
    var inputs = document.getElementsByClassName('StatusMessages');
    Array.prototype.forEach.call(inputs, function(el, index, array) {
        el.style.display = 'none';
        var title = el.getElementsByClassName('StatusMessages-title')[0];
        var message = el.getElementsByClassName('StatusMessage')[0];
        // What kind of alert is it?
        var type = 'info';
        if (message.classList.contains('StatusMessage--status')) {
            type = 'success';
        } else if (message.classList.contains('StatusMessage--warning')) {
            type = 'warning';
        } else if (message.classList.contains('StatusMessage--error')) {
            type = 'error';
        }
        // Add to the queue
        messages.push({
            title: title.innerHTML,
            type: type,
            html: message.innerHTML
        });
    });
    if (messages.length) {
        swal.queue(messages)
    }

    /**
     * Media sidebar modal windows
     */
    var anchors = document.getElementsByClassName('media-link');
    for (var z = 0; z < anchors.length; z++) {
        var elem = anchors[z];
        elem.onclick = function() {
            swal({
                title: this.dataset.title,
                customClass: 'features-modal ' + this.dataset.type,
                html: this.dataset.embed,
                showCloseButton: true,
            }).catch(swal.noop);
        };
    }
    /**
     * Media sidebar gradient removal / addition
     */
    var mediaSidebar = document.getElementsByClassName("Field--name-field-features-media");
    var mediaSidebarWrapper = document.getElementsByClassName('gradient-wrapper')[0];
    if (mediaSidebar.length) {
        mediaSidebar = mediaSidebar[0];
        mediaSidebarWrapper.addEventListener('scroll', function(evt) {
            if (mediaSidebarWrapper.scrollTop === (mediaSidebarWrapper.scrollHeight - mediaSidebarWrapper.offsetHeight)) {
                mediaSidebar.classList.add('gradient-fade');
            } else {
                mediaSidebar.classList.remove('gradient-fade');
            }
        });
    }
    /**
     * Scroll to team block if URL has #about
     */
    if (window.location.hash && window.location.hash === '#team') {

        // We need to check which block is currently visisble
        var teamBlock = document.getElementsByClassName('Block--views-blockteam-team-list-block');
        var teamBlockYtt = document.getElementsByClassName('Block--views-blockteam-block-1');
        if (teamBlock.length) {
            for (var z = 0; z < teamBlock.length; z++) {
                var objStyle = window.getComputedStyle(teamBlock[z]);
                if (objStyle && objStyle.display === 'block') {
                    scrollTo(document.documentElement, teamBlock[z].offsetTop - 30, 400);
                }
            }
        }
        if (teamBlockYtt.length) {
            scrollTo(document.documentElement, teamBlockYtt[0].offsetTop - 30, 400);
        }
    }
    /**
     * Search block trigger and close
     */
    var searchTrigger = document.querySelectorAll('div.search > a');
    var searchBlock = document.getElementsByClassName('Block--search-form-block');
    var searchClose = document.getElementsByClassName('search-close');
    var searchInput = document.getElementById('search-block-form').querySelectorAll('input[type=search]');
    for (var z = 0; z < searchTrigger.length; z++) {
        var elem = searchTrigger[z];
        elem.onclick = function(e) {
            e.preventDefault();
            searchBlock[0].classList.add('is-active');
            // Focus search bar for user
            setTimeout(function() {
                searchInput[0].select();
            }, 1000);

            var mobileMenus = document.querySelectorAll(".nav-active");
            var mobileTrigger = document.querySelectorAll(".hamburger");
            for (var i = 0; i < mobileMenus.length; i++) {
                mobileMenus[i].classList.remove('nav-active');
                mobileTrigger[i].classList.remove('is-active');
            }

        };
    }
    // searchTrigger[0].onclick = function(e) {
    //     e.preventDefault();
    // };
    searchClose[0].onclick = function(e) {
        searchBlock[0].classList.remove('is-active');
    };
    /**
     * Init masonry if required
     */
    var grid;
    if (grid = document.querySelector('.equal-grid-layout')) {
        var filter = document.getElementsByClassName('content-list-filter');
        if (filter.length > 0) {
            filter[0].classList.add('content-list-filter-absolute');
        }
        var msnry = new Masonry(grid, {
            columnWidth: '.content-list-item:nth-child(3)',
            itemSelector: 'none',
            stamp: '.content-list-filter, h1.title, .taxonomy-term',
            percentPosition: true,
            gutter: 0,
            stagger: 100,
            transitionDuration: '0.3s',
            // nicer reveal transition
            visibleStyle: {
                transform: 'translateY(0)',
                opacity: 1
            },
            hiddenStyle: {
                transform: 'translateY(100px)',
                opacity: 0
            }
        });
        imagesLoaded(grid, function() {
            var items = grid.querySelectorAll('.content-list-item:not(.content-list-filter)');
            msnry.options.itemSelector = '.content-list-item:not(.content-list-filter)';
            msnry.appended(items);
            msnry.layout();
        });
    }

    /**
     * In this section menu
     */
    var sectionMenu = document.querySelector('nav.menu--in-this-section h2');

    if (sectionMenu) {
      sectionMenu.onclick = function() {
          this.parentNode.classList.toggle('menu-open');
      }
    }


    // Trigger a resize action on load
    windowresize();
});
var windowresize = function() {
    var windowWidth = window.screen.width;
    // Equalise footer box heights
    var inputs = document.getElementsByClassName('footer-square');
    Array.prototype.forEach.call(inputs, function(el, index, array) {
        if (windowWidth > 300) {
            el.style.minHeight = el.offsetWidth + 'px';
        } else {
            el.style.minHeight = 'auto';
        }
    });
}

function scrollTo(element, to, duration) {
    if (duration <= 0) return;
    var difference = to - element.scrollTop;
    var perTick = difference / duration * 10;
    setTimeout(function() {
        element.scrollTop = element.scrollTop + perTick;
        if (element.scrollTop === to) return;
        scrollTo(element, to, duration - 10);
    }, 10);
}
